module.exports = __webpack_public_path__ + "static/media/nt.660f84de.jpg";